import type { JobPost } from '~/api/jobPosts/types';

import { Activity } from '~/constants/constants';

// generateJSON works only in the browser
// https://tiptap.dev/docs/editor/api/utilities/html#generating-json-from-html
const description = {
  type: 'doc',
  content: [
    {
      type: 'paragraph',
      content: [
        {
          type: 'text',
          text: 'Lorem ipsum dolor sit amet.',
        },
      ],
    },
  ],
};

export const userPhotographyJobPost = {
  id: 1,
  source: 'Internal',
  title: 'Foto- en videograaf voor trouw',
  activityIds: [Activity.photography, Activity.audiovisual, Activity.digitalDesign],
  description,
  region: 'Abroad',
  locationType: 'Hybrid',
  price: 350,
  priceType: 'HalfDaily',
  experienceLevel: null,
  startsAt: new Date('2025-07-07T00:00:00').toISOString(),
  endsAt: null,
  closesAt: null,
  clientName: 'Kelly Verbier Visuals',
  applyMode: 'InternalEmail',
  externalClientEmail: null,
  externalLink: null,
  logoUrl: 'https://cataas.com/cat/says/1?type=square',
  createdAt: new Date('2025-07-07T09:00:00').toISOString(),
  updatedAt: new Date('2025-07-07T09:00:00').toISOString(),
  status: 'Open',
  userHasCreated: true,
  userHasBookmarked: false,
  userHasApplied: false,
} as const satisfies JobPost;

export const userTranslatorJobPost = {
  id: 2,
  source: 'Internal',
  title: 'Vertaling Thais naar Nederlands',
  activityIds: [Activity.languageAndCommunication],
  description,
  region: null,
  locationType: 'Remote',
  price: 0.1,
  priceType: 'PricePerWord',
  experienceLevel: null,
  startsAt: new Date('2025-07-07T00:00:00').toISOString(),
  endsAt: null,
  closesAt: null,
  clientName: "Lisa's story telling",
  applyMode: 'InternalEmail',
  externalClientEmail: null,
  externalLink: null,
  logoUrl: 'https://cataas.com/cat/says/2?type=square',
  createdAt: new Date('2025-07-08T09:00:00').toISOString(),
  updatedAt: new Date('2025-07-08T09:00:00').toISOString(),
  status: 'Open',
  userHasCreated: false,
  userHasBookmarked: true,
  userHasApplied: false,
} as const satisfies JobPost;

const adminJobPost = {
  id: 3,
  source: 'External',
  title: 'Full-stack developer',
  activityIds: [Activity.itDevelopment],
  description,
  region: 'EastFlanders',
  locationType: 'Hybrid',
  price: 500,
  priceType: 'Daily',
  experienceLevel: 'Senior',
  startsAt: new Date('2025-09-01T00:00:00').toISOString(),
  endsAt: new Date('2025-12-31T00:00:00').toISOString(),
  closesAt: new Date('2025-08-01T00:00:00').toISOString(),
  clientName: 'Deloitte',
  applyMode: 'ExternalUrl',
  externalClientEmail: null,
  externalLink: 'https://deloittebe.avature.net/en_US/careers/SearchJobs',
  logoUrl: 'https://cataas.com/cat/says/3?type=square',
  createdAt: new Date('2025-07-09T09:00:00').toISOString(),
  updatedAt: new Date('2025-07-09T09:00:00').toISOString(),
  status: 'Open',
  userHasCreated: false,
  userHasBookmarked: false,
  userHasApplied: false,
} as const satisfies JobPost;

const userInstragramContentJobPost = {
  id: 4,
  source: 'Internal',
  title: 'Maken nieuwe content op Instagram',
  activityIds: [Activity.onlineContentCreation],
  description,
  region: 'Abroad',
  locationType: 'Hybrid',
  price: 100,
  priceType: 'Fixed',
  experienceLevel: null,
  startsAt: null,
  endsAt: null,
  closesAt: null,
  clientName: 'Gen-z-ers',
  applyMode: 'InternalEmail',
  externalClientEmail: null,
  externalLink: null,
  logoUrl: 'https://cataas.com/cat/says/4?type=square',
  createdAt: new Date('2025-07-10T09:00:00').toISOString(),
  updatedAt: new Date('2025-07-10T09:00:00').toISOString(),
  status: 'Open',
  userHasCreated: false,
  userHasBookmarked: false,
  userHasApplied: false,
} as const satisfies JobPost;

const userInteriorJobPost = {
  id: 5,
  source: 'Internal',
  title: 'Inrichting nieuwe eetzaak',
  activityIds: [Activity.stylingAndInterior],
  description,
  region: 'Antwerp',
  locationType: 'Hybrid',
  price: null,
  priceType: 'Tbd',
  experienceLevel: null,
  startsAt: null,
  endsAt: null,
  closesAt: null,
  clientName: 'The Architects',
  applyMode: 'InternalEmail',
  externalClientEmail: null,
  externalLink: null,
  logoUrl: 'https://cataas.com/cat/says/5?type=square',
  createdAt: new Date('2025-07-11T09:00:00').toISOString(),
  updatedAt: new Date('2025-07-11T09:00:00').toISOString(),
  status: 'Open',
  userHasCreated: false,
  userHasBookmarked: false,
  userHasApplied: false,
} as const satisfies JobPost;

export const jobPosts = [
  userPhotographyJobPost,
  userTranslatorJobPost,
  adminJobPost,
  userInstragramContentJobPost,
  userInteriorJobPost,
] as const satisfies JobPost[];
